<template>
    <div>
        <input type="hidden" :name="'date_validate'+ this._uid" v-model="date_validate" v-validate="'required'" />
        
        <input type=text :value="dateValue" :class="'datepicker'+ this._uid +' form-control'" placeholder="JJ/MM/AAAA" />

        <span class="text-danger" v-if="errors.has('date_validate' + this._uid)">{{ $t('validations.required') }}</span>
    </div>
</template>

<script>
  import moment from 'moment'
  import 'bootstrap-datepicker'

  export default {
    inject: ['$validator'],
    props: {
      value: [Object, String, Date],
      required: {
        type: Boolean,
        required: false,
        default: false,
      },
      loaded: false,
    },
    data() {
      return {
        dateValue: undefined,
      }
    },
    created() {
      let self = this
    },
    mounted: function() {
      let self = this
      $('.datepicker' + this._uid)
        .datepicker({
          format: 'dd/mm/yyyy',
          autoclose: true,
          clearBtn: false,
        })
        .on('change', function() {
          let val = $('.datepicker' + self._uid).val()

          if (val != '' && val != undefined) self.dateValue = moment(val, 'DD/MM/YYYY')
          else self.dateValue = null
  
          self.$emit('input', self.dateValue)
        })
    },
    watch: {
      value: {
        immediate: true,
        handler(newValue, oldVal) {
          if (newValue == null) {
            this.dateValue = null
          } else if (typeof newValue === 'object' && !(newValue instanceof Date)) {
            this.dateValue = moment(newValue.utc().format()).format('DD/MM/YYYY')
          } else {
            this.dateValue = moment(newValue).format('DD/MM/YYYY')
          }
  
          if (newValue !== null && oldVal == null) $('.datepicker' + this._uid).datepicker('setDate', this.dateValue)
        },
      },
    },
    computed: {
      date_validate: function() {
        if (!this.required) {
          return 'notrequired'
        } else {
          return this.dateValue
        }
      },
    },
  }
</script>

<style>

  .vdp-datepicker input {
    background-color: white !important;
  }

</style>


// WEBPACK FOOTER //
// src/shared/components/MomentDatePicker.vue